import { c as _c } from "react/compiler-runtime";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
export const SchemaOrganization = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <script dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "Organization",
        url: getOrigin(),
        logo: {
          "@type": "ImageObject",
          url: `${getOrigin()}/logo.png`,
          height: "78",
          width: "137"
        },
        name: replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E"),
        sameAs: isChannel(["snapp-ir"]) ? ["https://www.instagram.com/snapp_team", "https://twitter.com/snapp_team", "https://www.linkedin.com/company/snapp.ir"] : ["https://www.instagram.com/snapptrip", "https://twitter.com/snapptrip", "https://www.linkedin.com/company/snapptrip-com"]
      })
    }} suppressHydrationWarning={true} type="application/ld+json" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};